import { render, staticRenderFns } from "./RequestContacts.vue?vue&type=template&id=319741f7"
import script from "./RequestContacts.vue?vue&type=script&lang=js"
export * from "./RequestContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports